//import Vue from 'vue'
import moment from 'moment'

const _DATA = () => {
    const DATA = {}
    DATA.METHODS = {}
    DATA.RENDERERS = {
        FIRST_NAME: (instance, td, row, col, prop, value, cellProperties) => {
            td.innerText = ''
        
            if (value) {
                let parts = value.split(' ');
                td.innerText = parts[0];
            }
        
            return td
        },
        LAST_NAME: (instance, td, row, col, prop, value, cellProperties) => {
            td.innerText = ''
        
            if (value) {
                let parts = value.split(' ');
                if (parts.length > 1) {
                   parts.shift();
                   td.innerText = parts.join(' ');
                }
            }
        
            return td
        },
        YYYY_MM_DD: (instance, td, row, col, prop, value, cellProperties) => {
            td.innerText = ''
        
            if (value) {
                td.innerText = moment(value).format('YYYY/MM/DD')
            }
        
            return td
        },
        YYYY_MM_DD_hh_mm: (instance, td, row, col, prop, value, cellProperties) => {
            td.innerText = ''
        
            if (value) {
                td.innerText = moment(value).format('YYYY/MM/DD HH:mm')
            }
        
            return td
        },
        status: (instance, td, row, col, prop, value, cellProperties) => {
            switch (value) {
                case 'draft':
                    td.innerHTML = '登録済'
                    break
                case 'activated':
                    td.innerHTML = '有効確認済'
                    break
                case 'error_timeout':
                    td.innerHTML = '<span class="text-danger">無効(期限エラー)</span>'
                    break
                case 'error_invalid':
                    td.innerHTML = '<span class="text-danger">無効(登録エラー)</span>'
                    break
            }
            return td
        },
        numeric: (instance, td, row, col, prop, value, cellProperties) => {
            td.innerText = ''

            td.classList.add('text-right')
            if (cellProperties.readOnly) {
                td.classList.add('htDimmed')
            }
            if (typeof value === 'number') {
                td.innerText = value.toLocaleString()
            } else if (typeof value === 'string') {
                td.innerText = value.split("\n").map((v) => {
                    return Number(v).toLocaleString()
                }).join("\n")
            }

            return td
        },
        shipping_tracking_log: (instance, td, row, col, prop, value, cellProperties) => {
            td.innerText = value
            td.style = [
                'max-width: 200px;',
                'white-space: nowrap;',
            ].join('')
            return td
        },
    }
    DATA.FIELDS = {
    }
    DATA.FIELDS_ALL = []
    return DATA
}

export default _DATA

